import { post, fetch, patch, put } from '@/utils/http';
const API_ROOT = process.env.API_ROOT;

//async function getChannelArticleList(channelId, channelAlias, parentAlias, page, ){
async function getChannelArticleList(queryParam){
    return post(`${API_ROOT}/getChannelArticleList`, {
        channelId: queryParam.channelId,
        channelAlias: queryParam.channelAlias,
        parentAlias: queryParam.parentAlias,
        page:queryParam.page,
        limit:queryParam.limit,
        manualSort: queryParam.manualSort,
        qs: queryParam.qs,
        field: queryParam.field,
    });
}

async function getAllRewardList(channelAlias){
    return post(`${API_ROOT}/getRewardList`, {        
        channelAlias: channelAlias        
    });
}

async function getAllPatentList(channelAlias){
    return post(`${API_ROOT}/getPatentList`, {        
        channelAlias: channelAlias        
    });
}

async function getChronicleList(channelAlias){
    return post(`${API_ROOT}/getBioList`, {        
        channelAlias: channelAlias        
    });
}

async function getStickyArticleList(channelId, channelAlias, limit){
    return post(`${API_ROOT}/getChannelStickyArticleList`, {
        channelId: channelId,
        channelAlias: channelAlias,
        limit: limit
    });
}

async function getArticleDetail(articleId){
    return post(`${API_ROOT}/getArticleDetail`, {
        articleId: articleId,        
    });
}

async function getBlockItemList(blockId, blockAlias, limit){
    return post(`${API_ROOT}/getBlockItemList`, {
        blockId: blockId,       
        blockAlias: blockAlias,
        limit: limit
    });
}

async function getFullBlockList(aliases){
    return post(`${API_ROOT}/getFullBlockList`, {
        aliases: aliases,
    });
}


async function getBookList(){
    return post(`${API_ROOT}/getBookList`);
}

async function getChannelPage(channelAlias){
    return post(`${API_ROOT}/getChannelPage`, {        
        channelAlias: channelAlias       
    });
}

async function getAwardList(channelAlias){
    return post(`${API_ROOT}/getWangxuanAwardList`, {        
        channelAlias: channelAlias       
    });
}

export{
    getChannelArticleList,
    getStickyArticleList,
    getArticleDetail,
    getBlockItemList,
    getFullBlockList,
    getBookList,
    getAllRewardList,
    getAllPatentList,
    getChronicleList,
    getChannelPage,
    getAwardList,
}


// WEBPACK FOOTER //
// ./src/api/content.js